// OfflineToast.js
import React, { useEffect } from "react";
import { useToast } from "./Toast";

const OfflineToast = () => {
  const { showToast, hideToast } = useToast();

  useEffect(() => {
    const handleOffline = () => {
      // Show a persistent toast (duration Infinity)
      showToast("You are offline. Changes will sync when connection is restored.", Infinity);
    };

    const handleOnline = () => {
      hideToast(); // Clear the persistent offline toast
      showToast("Connection restored!", 3000);
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // Check current state on mount
    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [showToast, hideToast]);

  return null;
};

export default OfflineToast;